import React, { useState } from "react"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import { useForm } from "react-hook-form"
import { SignupInput } from "../../../common"
import { updatePersonalDetails } from "../../../../services/auth"
import classNames from "classnames"
import { FormattedMessage, useIntl } from "react-intl"

const DetailsForm = () => {
  const [loading, setLoading] = useState(false)
  const auth = useSelector((state) => state.auth)
  const [editable, setEditable] = useState({
    name: false,
    phoneNumber: false,
    email: false,
    position: false,
  })

  const { formatMessage } = useIntl()

  const {
    register,
    handleSubmit,
    formState: { errors, touchedFields },
    getValues,
    setValue,
    watch,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      email: auth.email,
    },
  })

  watch(["name", "phoneNumber", "email", "position"])

  const values = getValues()

  const onSubmit = async () => {
    if (loading) return

    //
    try {
      const toUpdate = {}

      if (editable.email) toUpdate.email = values.email

      if (Object.keys(toUpdate).length === 0) return

      setLoading(true)
      await updatePersonalDetails(toUpdate)
      toast.success(formatMessage({ id: "toast.detailsUpdatedSuccessfully" }))

      setEditable({
        email: false,
      })
    } catch {
      toast.error(formatMessage({ id: "toast.somethingWentWrongTryAgain" }))
    }
    setLoading(false)
    //
  }

  const handleCancel = () => {
    setEditable({
      email: false,
    })

    // Set previous defaults
    setValue("email", auth.user.email)
  }

  return (
    <form className="details-form" onSubmit={handleSubmit(onSubmit)}>
      <div className="details-form__inputs">
        <SignupInput
          {...{
            name: "email",
            placeholder: formatMessage({ id: "common.orYourEmail" }),
            register: register("email", {
              pattern: {
                value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i,
                message: formatMessage({ id: "common.invalidEmailAddress" }),
              },
            }),
            error: errors.email?.message,
            touched: touchedFields.email,
            value: values.email,
            showEditButton: true,
            editable: editable.email,
            setEditable: () => setEditable({ ...editable, email: true }),
            label: formatMessage({ id: "common.email" }),
          }}
        />
      </div>
      <div className="details-form__buttons">
        <button
          className={classNames("btn btn--small primary", {
            disabled: loading,
          })}
        >
          <FormattedMessage id="common.saveChanges" />
        </button>
        <button
          className="btn btn--small tertiary"
          type="button"
          onClick={handleCancel}
        >
          <FormattedMessage id="common.cancel" />
        </button>
      </div>
    </form>
  )
}

export default DetailsForm
